angular.module('cfn').factory('cfnGridModel', function() {
  var service = {};

  service.init = function(scope, element, attrs) {
    var serviceInstance = {};

    scope.updateModel = function() {
      app.startPerfTimer('cfnGridUpdateModel');

      if (scope.ngModel) {
        // remove old selection information
        $.each(scope.ngModel, function(idx, ob) {
          ob.$cfngrid_selected = undefined;
        });

        // mark elements selected that actually are currently selected
        $.each(scope.selected, function(idx, v) {
          v.$cfngrid_selected = true;
        });

        // Refresh list of selected values to throw out removed entries
        scope.selected = {};

        $.each(scope.ngModel, function(idx, ob) {
          if (ob.$cfngrid_selected) {
            scope.selected[ob.id] = ob;
          }
        });

        scope.view.amount = scope.ngModel.length;
      } else {
        scope.view.amount = 0;
      }

      var ds = scope.datasource();
      scope.updateView(ds);

      // Make sure it is already initialized (uses $timeout)
      if (scope.$cfnGridFnHacks) {
        // Legacy call
        scope.$cfnGridFnHacks.afterUpdateModel();
      }

      if (scope.afterupdatemodel()) {
        scope.afterupdatemodel()(scope.name);
      }

      app.stopPerfTimer('cfnGridUpdateModel');
    };

    serviceInstance.addWatchers = function() {
      // Watch the model, but intentionally not the content because
      // reconstructing the whole table is expensive (= slow)

      if (scope.watchList) {
        scope.$watch(
          'ngModel.length',
          function() {
            //console.debug("model changed");
            scope.updateModel();
          },
          false
        );
      } else {
        scope.$watch(
          'ngModel',
          function() {
            scope.updateModel();
          },
          false
        );
        scope.$watch(
          'ngModel.length',
          function() {
            scope.updateModel();
          },
          false
        );
      }
    };
    return serviceInstance;
  };

  return service;
});
